/** Marcadores de superfície — dark mode via CSS em index.css (.dark .admin-structure-classification-tab). */
export const CLASSIFICATION_TAB_ROOT = "admin-structure-classification-tab";

export const ctd = {
  surfaceWhite: "classification-tab-surface-white",
  surfaceMuted: "classification-tab-surface-muted",
  text: "classification-tab-text",
  docPanel: "classification-tab-doc-panel",
  docHeader: "classification-tab-doc-header",
  docBody: "classification-tab-doc-body",
  iconHost: "classification-tab-icon-host",
  hoverSubtle: "classification-tab-hover-subtle",
  gradeBody: "classification-tab-grade-body",
  optionIdle: "classification-tab-option-idle",
  optionScore: "classification-tab-option-score",
  normIdle: "classification-tab-norm-idle",
  border: "classification-tab-border",
} as const;

/** Ícones MUI herdam cor do texto (light #4d4d4d, dark foreground). */
export const classificationTabIconSx = { fontSize: 24, color: "currentColor" } as const;
